import React, { useEffect, useState } from "react"
import { ContentBase } from "../../@types/CapioWeb/core"
import { getContentByType } from "../Core"
import { useQueryClient } from "react-query"
import { useLocation } from "react-router-dom"

export interface BlockResolverProps {
	blocks?: ContentBase[]
}

const BlockResolver: React.FC<BlockResolverProps> = (props) => {
	const [cacheCleared, clearCacheState] = useState(0)

	const clearCache = (modelType) => {
		if (
			cacheCleared == 0 &&
			(modelType == "CapioNexusFormContainerBlock" ||
				modelType == "CapioNexusSearchCareInAppBlock")
		) {
			clearCacheState(1)
			const location = useLocation()
			const path = location.pathname + location.search
			const queryClient = useQueryClient()
			queryClient.invalidateQueries({ queryKey: [path] })
		}
	}

	return (
		<>
			{props.blocks &&
				props.blocks.map((block) => {
					const { id } = block.contentLink
					clearCache(block.modelType)
					const blockType = getContentByType(block.modelType)
					return React.createElement(blockType, {
						...(block && typeof blockType === "function" && block),
						key: id,
					})
				})}
		</>
	)
}

export { BlockResolver }
